var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homebox"},[_c('ul',{staticClass:"homebtn"},[_c('li',[_c('img',{attrs:{"src":require("@/assets/image/homebtn_qy.png")}})]),_c('li',[_c('img',{attrs:{"src":require("@/assets/image/homebtn_gr.png")}})])])])
}]

export { render, staticRenderFns }